import script from "./ServicerPayoffAddressFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServicerPayoffAddressFormModal.vue?vue&type=script&setup=true&lang=ts"

import "./ServicerPayoffAddressFormModal.vue?vue&type=style&index=0&id=c60e1998&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c60e1998"]])

export default __exports__